export const constructStrRep = (obj) => {
  return obj.str_representation || obj.title || "Vakansbokningslogg";
};

export const detailUrl = ({ id }) =>
  `/rental-notifications/vacancy-bookings/detail/${id}`;
